import { Box, Typography } from '@mui/material';
import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SummaryItem } from '~/components/MyWorkspace/SummaryItem';
import { TooltippedTruncatedText } from '~/components/TooltippedTruncatedText';
import { People } from '~/services/Http';

import { useSxStyles } from './useStyles';

export interface Props {
  listItem: People.TaskDto;
}

export const Task: React.FC<Props> = ({ listItem }) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();

  const statusSxStyles = listItem.status && {
    ...sxStyles.status,
    ...(listItem.status.code === People.TaskStatusEnum.NEW &&
      sxStyles.statusNew),
    ...(listItem.status.code === People.TaskStatusEnum.IN_PROGRESS &&
      sxStyles.statusInProgress),
    ...(listItem.status.code === People.TaskStatusEnum.COMPLETED &&
      sxStyles.statusCompleted),
  };

  const dueDateSxStyles = {
    ...(moment(listItem.dueDate) > moment() &&
      moment(listItem.dueDate) < moment().add(1, 'week') &&
      sxStyles.dueDateSoon),
    ...(moment(listItem.dueDate) < moment() && sxStyles.dueDatePast),
  };

  return (
    <SummaryItem
      href={`/page-ui2-redirect?empId=${listItem.assignee?.id}&area=collaboration`}
      primaryElement={
        <Box sx={sxStyles.flex}>
          <TooltippedTruncatedText>{listItem.title}</TooltippedTruncatedText>
          {listItem.status && (
            <Box sx={sxStyles.flexCenter}>
              <Typography sx={statusSxStyles}>
                {listItem.status.value}
              </Typography>
            </Box>
          )}
        </Box>
      }
      secondaryElement={
        <>
          {`${listItem.type.value}`}
          {listItem.dueDate && (
            <>
              {`, `}
              <Box component="span" sx={dueDateSxStyles} data-id="date">
                {`${t('dueOn')} ${moment(listItem.dueDate).format('L')}`}
              </Box>
            </>
          )}
        </>
      }
    />
  );
};
